import React, { memo } from 'react'
import HelpIcon from 'transfix-icons/build/HelpIcon'
import { MapMarker, TStopType } from 'transfix-ui/components/MapMarker'
import { Tooltip } from 'transfix-ui/components/Tooltip'
import { makeStyles } from 'transfix-ui/core'
import Box from 'transfix-ui/core/Box'
import Typography from 'transfix-ui/core/Typography'
import { Maybe } from 'types/graphqlTypes'
import { formatCityState } from 'utils/formatCityState'
import DISPLAY from 'constants/display'
import { TEST_IDS } from '../constants'
import { TMarketInsightsLocation } from '../types'

const useMarketInsightsLocationDataStyles = makeStyles(theme => ({
  helpIcon: {
    marginLeft: theme.spacing(1),
  },
  mapMarker: {
    marginRight: theme.spacing(1),
  },
}))

interface IMarketInsightsLocationDataProps {
  dataTestId?: string
  datCityState: Maybe<string>
  location: Maybe<TMarketInsightsLocation>
  stopType: TStopType
  value: Maybe<number>
}

export const MarketInsightsLocationData = memo<IMarketInsightsLocationDataProps>(
  ({ datCityState, dataTestId, location, stopType, value }) => {
    const classes = useMarketInsightsLocationDataStyles()
    const { city, stateCode } = location ?? {}
    const formattedLocation = formatCityState(city ?? '', stateCode ?? '') || DISPLAY.empty
    const formattedPercentage = value ? `${value.toFixed(2)}%` : `${DISPLAY.emptyDash}%`

    return (
      <Box data-test={dataTestId} textAlign='center'>
        <Box display='inline-flex' justifyContent='center' alignItems='center'>
          <MapMarker className={classes.mapMarker} sequence={0} type={stopType} />
          <Typography data-test={TEST_IDS.locationText} variant='h3'>
            {formattedLocation}
          </Typography>
          {datCityState && (
            <Tooltip
              trigger={<HelpIcon className={classes.helpIcon} color='coolGray5' size='large' />}>
              <Typography style={{ backgroundColor: 'transparent' }} variant='body2'>
                Market City:
              </Typography>
              <Typography style={{ backgroundColor: 'transparent' }} variant='body1'>
                {datCityState}
              </Typography>
            </Tooltip>
          )}
        </Box>
        <Typography data-test={TEST_IDS.percentageChangeText} variant='h2'>
          {formattedPercentage}
        </Typography>
        <Typography color='textSecondary' variant='body2'>
          % Change in LH+F
        </Typography>
      </Box>
    )
  }
)

export default MarketInsightsLocationData
